import React from 'react';
import { Link } from 'react-router-dom';

const RefundPage = () => (
  <div dir="ltr" className="min-h-screen bg-gray-50 py-16 px-4">
    <div className="max-w-2xl mx-auto bg-white rounded-2xl shadow p-10">
      <Link to="/" className="text-sm text-purple-600 hover:underline mb-8 inline-block">← Back to home</Link>
      <h1 className="text-3xl font-bold text-gray-900 mb-2">Refund Policy</h1>
      <p className="text-sm text-gray-400 mb-8">Last updated: June 2026</p>

      <section className="space-y-6 text-gray-700 text-sm leading-relaxed">
        <div>
          <h2 className="font-semibold text-gray-900 mb-1">No Refund Policy</h2>
          <p>All sales are final. Due to the instant digital delivery of this product, <strong>no refunds are issued once the purchase is completed and access to the course has been granted.</strong></p>
        </div>
        <div>
          <h2 className="font-semibold text-gray-900 mb-1">Before You Buy</h2>
          <p>We encourage you to carefully read the full course description and syllabus before purchasing. If you have any questions about the course content, contact us before completing your purchase.</p>
        </div>
        <div>
          <h2 className="font-semibold text-gray-900 mb-1">Exceptions</h2>
          <p>In the rare case of a duplicate charge or a payment error, please contact us within 7 days and we will investigate promptly.</p>
        </div>
        <div>
          <h2 className="font-semibold text-gray-900 mb-1">Contact</h2>
          <p>Billing questions: <a href="mailto:shovalrecruiting@gmail.com" className="text-purple-600 hover:underline">shoval-recruiting@gmail.com</a></p>
        </div>
      </section>
    </div>
  </div>
);

export default RefundPage;
